jQuery(window).on("load", function () {
  "use strict";

  /*  ===================================
   Loading Timeout
   ====================================== */
  $("#loader-fade").fadeOut(800);
});

jQuery(function ($) {
  "use strict";

  const $window = $(window);
  const WINDOWW_SIZE = $window.width();
  const MOBILE_SIZE = 767;
  const TABLET_SIZE = 991;

  /* ===================================
     Testimonials Swiper
     ====================================== */
  if ($(".js-testimonial-swiper").length) {
    new Swiper(".js-testimonial-swiper", {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      speed: 500,
      centeredSlides: true,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  /* ===================================
     Nav Scroll
     ====================================== */

  $(".scroll").on("click", function (event) {
    event.preventDefault();
    $('html,body').animate({
      scrollTop: $(this.hash).offset().top - 40
    }, 1100);
  });
  /* ====================================
     Nav Fixed On Scroll
     ======================================= */

  $(window).on('scroll', function () {
    if ($(this).scrollTop() >= 80) { // Set position from top to add class
      $('header').addClass('header-appear');
    } else {
      $('header').removeClass('header-appear');
    }
  });
  /*bottom menu fix*/
  if ($("nav.navbar").hasClass("bottom-nav")) {
    const navHeight = $(".bottom-nav").offset().top;
    $(window).on("scroll", function () {
      if ($window.scrollTop() > navHeight) {
        $('header').addClass('header-appear');
      } else {
        $('header').removeClass('header-appear');
      }
    });
  }

  /* ===================================
     Side Menu
     ====================================== */

  const $sidemenuToggle = $(".sidemenu_toggle");
  if ($sidemenuToggle.length) {
    $sidemenuToggle.on("click", function () {
      $(".pushwrap").toggleClass("active");
      $(".side-menu").addClass("side-menu-active"), $("#close_side_menu").fadeIn(700)
    }), $("#close_side_menu").on("click", function () {
      $(".side-menu").removeClass("side-menu-active"), $(this).fadeOut(200), $(".pushwrap").removeClass("active")
    }), $(".side-nav .navbar-nav .nav-link").on("click", function () {
      $(".side-menu").removeClass("side-menu-active"), $("#close_side_menu").fadeOut(200), $(".pushwrap").removeClass("active")
    }), $("#btn_sideNavClose").on("click", function () {
      $(".side-menu").removeClass("side-menu-active"), $("#close_side_menu").fadeOut(200), $(".pushwrap").removeClass("active")
    })
  }
  /* =====================================
     Wow
     ======================================== */

  if (WINDOWW_SIZE > MOBILE_SIZE) {
    const wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: false,
      live: true
    });
    new WOW().init();
  }

  /* ===================================
      Animated Cursor
     ====================================== */

  // function animatedCursor() {
  //
  //   if ($("#animated-cursor").length) {
  //     const $animatedWrap = $(".animated-wrap");
  //
  //     let e = {x: 0, y: 0}, t = {x: 0, y: 0}, n = .25, o = !1, a = document.getElementById("cursor"),
  //       i = document.getElementById("cursor-loader");
  //     TweenLite.set(a, {xPercent: -50, yPercent: -50}), document.addEventListener("mousemove", function (t) {
  //       const n = window.pageYOffset || document.documentElement.scrollTop;
  //       e.x = t.pageX, e.y = t.pageY - n
  //     }), TweenLite.ticker.addEventListener("tick", function () {
  //       o || (t.x += (e.x - t.x) * n, t.y += (e.y - t.y) * n, TweenLite.set(a, {x: t.x, y: t.y}))
  //     }),
  //       $animatedWrap.mouseenter(function (e) {
  //         TweenMax.to(this, .3, {scale: 2}), TweenMax.to(a, .3, {
  //           scale: 2,
  //           borderWidth: "1px",
  //           opacity: .2
  //         }), TweenMax.to(i, .3, {
  //           scale: 2,
  //           borderWidth: "1px",
  //           top: 1,
  //           left: 1
  //         }), TweenMax.to($(this).children(), .3, {scale: .5}), o = !0
  //       }),
  //       $animatedWrap.mouseleave(function (e) {
  //         TweenMax.to(this, .3, {scale: 1}), TweenMax.to(a, .3, {
  //           scale: 1,
  //           borderWidth: "2px",
  //           opacity: 1
  //         }), TweenMax.to(i, .3, {
  //           scale: 1,
  //           borderWidth: "2px",
  //           top: 0,
  //           left: 0
  //         }), TweenMax.to($(this).children(), .3, {scale: 1, x: 0, y: 0}), o = !1
  //       }),
  //
  //       $animatedWrap.mousemove(function (e) {
  //         let n, o, i, l, r, d, c, s, p, h, x, u, w, f, m;
  //         n = e, o = 2, i = this.getBoundingClientRect(), l = n.pageX - i.left, r = n.pageY - i.top, d = window.pageYOffset || document.documentElement.scrollTop, t.x = i.left + i.width / 2 + (l - i.width / 2) / o, t.y = i.top + i.height / 2 + (r - i.height / 2 - d) / o, TweenMax.to(a, .3, {
  //           x: t.x,
  //           y: t.y
  //         }), s = e, p = c = this, h = c.querySelector(".animated-element"), x = 20, u = p.getBoundingClientRect(), w = s.pageX - u.left, f = s.pageY - u.top, m = window.pageYOffset || document.documentElement.scrollTop, TweenMax.to(h, .3, {
  //           x: (w - u.width / 2) / u.width * x,
  //           y: (f - u.height / 2 - m) / u.height * x,
  //           ease: Power2.easeOut
  //         })
  //       }),
  //       $(".hide-cursor,.btn,.tp-bullets").mouseenter(function (e) {
  //         TweenMax.to("#cursor", .2, {borderWidth: "1px", scale: 2, opacity: 0})
  //       }),
  //       $(".hide-cursor,.btn,.tp-bullets").mouseleave(function (e) {
  //         TweenMax.to("#cursor", .3, {borderWidth: "2px", scale: 1, opacity: 1})
  //       }),
  //       $(".link").mouseenter(function (e) {
  //         TweenMax.to("#cursor", .2, {
  //           borderWidth: "0px",
  //           scale: 3,
  //           backgroundColor: "rgba(255,255,255,0.47)",
  //           opacity: .15
  //         })
  //       }), $(".link").mouseleave(function (e) {
  //       TweenMax.to("#cursor", .3, {
  //         borderWidth: "2px",
  //         scale: 1,
  //         backgroundColor: "rgba(255, 255, 255, 0)",
  //         opacity: 1
  //       })
  //     })
  //
  //   }
  //
  // }

  // if ($(window).width() > TABLET_SIZE) {
  //   setTimeout(function () {
  //     animatedCursor();
  //   }, 1000);
  // }

  /* ===================================
     Parallax
     ====================================== */

  if (WINDOWW_SIZE > TABLET_SIZE) {
    $(".parallaxie").parallaxie({
      speed: 0.4,
      offset: 0
    });
  }

  /* ===================================
     CubePortfolio
     ====================================== */


  /* ===================================
     Fancy Box
     ====================================== */
  $('[data-fancybox]').fancybox({
    protect: true,
    animationEffect: "fade",
    hash: null,
  });

  /* ===================================
     Rotating Text
     ====================================== */

  $("#js-rotating").Morphext({
    // The [in] animation type. Refer to Animate.css for a list of available animations.
    animation: "flipInX",
    // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
    separator: ",",
    // The delay between the changing of each phrase in milliseconds.
    speed: 3000,
    complete: function () {
      // Called after the entrance animation is executed.
    }
  });

  /* ===================================
     Gutenberg Gallery Lightbox
     ====================================== */

  const $blockGallery = $('.wp-block-gallery');
  if ($blockGallery.length) {
    // Prepare structure for CubePortfolio
    $blockGallery.each(function () {
      const $gallery = $(this);
      const $items = $gallery.find('.wp-block-image');
      const $newGallery = $('<div id="js-grid-mosaic-flat" class="cbp cbp-l-grid-mosaic-flat no-transition"></div>');

      // Transform each element to CubePortfolio format
      $items.each(function () {
        const $item = $(this);
        const $img = $item.find('img');
        const $figcaption = $item.find('figcaption');
        const $newItem = $('<div class="cbp-item"></div>');

        // Create new HTML structure
        const $newLink = $('<a href="' + $img.attr('src') + '" class="cbp-caption cbp-lightbox" data-title="' + $figcaption.text() + '"></a>');
        const $defaultWrap = $('<div class="cbp-caption-defaultWrap"></div>');
        const $activeWrap = $('<div class="cbp-caption-activeWrap"><div class="cbp-l-caption-alignCenter"><div class="cbp-l-caption-body"><div class="cbp-l-caption-title">' + $figcaption.text() + '</div><span class="arrow-icon"><i class="fa fa-arrow-right"></i></span></div></div></div>');

        // Assemble new structure
        $defaultWrap.append($img.clone());
        $newLink.append($defaultWrap);
        $newLink.append($activeWrap);
        $newItem.append($newLink);
        $newGallery.append($newItem);
      });

      // Clear gallery content and append new structure
      $gallery.empty().append($newGallery);
    });

    // Initialize CubePortfolio

    function initCubePortfolio() {
      $('#js-grid-mosaic-flat').cubeportfolio({
        layoutMode: 'mosaic',
        sortToPreventGaps: true,
        mediaQueries: [{
          width: 1500,
          cols: 5
        }, {
          width: 1100,
          cols: 4
        }, {
          width: 800,
          cols: 3
        }, {
          width: 480,
          cols: 2
        }, {
          width: 320,
          cols: 1
        }],
        defaultFilter: '*',
        animationType: 'quicksand',
        gapHorizontal: 0,
        gapVertical: 0,
        gridAdjustment: 'responsive',
        caption: 'zoom',
        displayType: 'bottomToTop',
        displayTypeSpeed: 100,
        lightboxDelegate: '.cbp-lightbox',
        lightboxGallery: true,
        lightboxTitleSrc: 'data-title',
        lightboxCounter: '<div class="cbp-popup-lightbox-counter">{{current}} of {{total}}</div>'
      });
    }

    initCubePortfolio();


    // let resizeTimer;
    // $window.on('resize', function () {
    //   clearTimeout(resizeTimer);
    //   resizeTimer = setTimeout(function () {
    //     const $grid = $('#js-grid-mosaic-flat');
    //
    //     if ($grid.length && typeof $grid.cubeportfolio === 'function') {
    //       try {
    //         $grid.cubeportfolio('destroy', true);
    //       } catch (e) {
    //         console.warn('CubePortfolio destroy failed:', e);
    //       }
    //
    //       initCubePortfolio();
    //     }
    //   }, 300);
    // });

  }
});
